export type DisabledReason = 'outdatedTerms' | 'deletion';
